import { render, staticRenderFns } from "./TemplateProductPodAssignerModal.vue?vue&type=template&id=129df057"
import script from "./TemplateProductPodAssignerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateProductPodAssignerModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports